import Head from 'next/head';
import { StakeLiquidityPrivately } from '@/components/StakeLiquidityPrivately';

const imgAirdropBoxStreamlineKameleon = '/assets/earn/airdrop-box.svg';

function EarnPage() {
  return (
    <>
      <Head>
        <title>ZKPool | Earn</title>
      </Head>

      <div
        className="relative flex w-full items-start justify-center overflow-hidden bg-[#0b0b0c] px-4 pb-16"
        style={{ minHeight: 'calc(100vh - 56px)' }}
      >
        <div
          aria-hidden
          className="pointer-events-none absolute inset-0"
          style={{
            background:
              'linear-gradient(180deg, #0b0b0c 0%, #0b0b0c 34%, #0a0a0c 100%)',
          }}
        />

        <div
          aria-hidden
          className="pointer-events-none absolute -left-[315px] top-[85px] h-[1402px] w-[1402px] overflow-hidden rounded-full max-w-[150vw]"
          style={{
            background:
              'radial-gradient(circle, rgba(28,109,117,0.62) 0%, rgba(12,24,27,0.34) 40%, rgba(5,7,10,0) 65%)',
            filter: 'blur(2px)',
          }}
        />

        <div
          aria-hidden
          className="pointer-events-none absolute left-[352px] top-[85px] h-[1402px] w-[1402px] overflow-hidden rounded-full max-w-[150vw]"
          style={{
            background:
              'radial-gradient(circle, rgba(73,31,33,0.6) 0%, rgba(32,17,19,0.32) 40%, rgba(6,5,7,0) 63%)',
            filter: 'blur(2px)',
          }}
        />

        <div
          aria-hidden
          className="pointer-events-none absolute inset-0"
          style={{
            background:
              'radial-gradient(ellipse at 50% 55%, rgba(12,14,17,0.95) 0%, rgba(10,11,14,0.82) 32%, rgba(8,9,12,0.5) 48%, rgba(7,8,10,0) 68%)',
          }}
        />

        <div className="relative z-10 flex h-full w-full max-w-[1200px] flex-col items-center pt-20 sm:pt-24">
          <div className="w-full max-w-[720px] space-y-6">
            <div className="flex w-full items-start gap-4 rounded-2xl bg-[#111828] px-6 py-4 shadow-[0_18px_60px_rgba(0,0,0,0.4)]">
              <div className="flex h-12 w-12 items-center justify-center">
                <img src={imgAirdropBoxStreamlineKameleon} alt="" className="h-full w-full" />
              </div>
              <div className="flex flex-1 flex-col gap-1">
                <p className="text-[20px] font-extrabold leading-[1.5] text-white">Participate in private liquidity staking to gain access to airdrop opportunities.</p>
                <p className="text-[12px] font-medium leading-[1.5] text-[#9fa9b6]">
                  All selected tokens are test tokens. The more you stake, the higher your chance of receiving airdrops.
                </p>
              </div>
            </div>

            <StakeLiquidityPrivately />
          </div>
        </div>
      </div>
    </>
  );
}

export default EarnPage;
